import { Component, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import get from 'lodash-es/get';

import { CAMPAIGN_CONSTANTS } from '@finder/shared/constants/app.constants';
import { LazyLoaderService } from '@finder/shared/services/lazy-loader/lazy-loader-service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import removeFinderClasses from '@finder/shared/utils/dom/removeFinderClasses';
import urlKebab from '@finder/shared/utils/string/urlKebab';

@Component({
    selector: 'app-dynamic-loader',
    templateUrl: './dynamic-loader.component.html',
    styleUrls: ['./dynamic-loader.component.scss'],
})
export class DynamicLoaderComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private viewContainerRef: ViewContainerRef,
        private lazyLoad: LazyLoaderService,
        private renderer: Renderer2,
        private winRef: WindowRef,
    ) {}

    ngOnInit() {
        const data = get(this.route.snapshot.data, 'svc');
        this.processData(data);
    }

    processData(data) {
        const isCampaign = get(data, CAMPAIGN_CONSTANTS.isCampaign, false);
        this.viewContainerRef.clear();
        let moduleToLoad = 'finder-detail';
        if (isCampaign) {
            // Lazy Load campaign component
            moduleToLoad = 'finder-campaign';
        }

        // Lazy Load details component
        this.lazyLoad.lazyLoadModule(moduleToLoad, this.viewContainerRef, {});

        // Remove existing finder classes
        const body = this.winRef.nativeWindow.document.body;
        removeFinderClasses(body, this.renderer);

        // Add classes
        const urlClass = urlKebab(this.winRef.nativeWindow);
        this.renderer.addClass(body, moduleToLoad);
        this.renderer.addClass(body, `${moduleToLoad}-${urlClass}`);
    }
}
